export enum BankTransferErrorType {
  None = 'None',
  BankTransferFailed = 'BankTransferFailed',
  MissingParameter = 'MissingParameter',
  Unknown = 'Unknown',
}
